//@flow
//Action Type Registered
export const PHOBOS_INV_SUBMIT_SUCCESS='PHOBOS_INV_SUBMIT_SUCCESS';
export const PHOBOS_INV_SUBMIT_ERROR='PHOBOS_INV_SUBMIT_ERROR';
export const PHOBOS_INV_SUBMITTED_COMPLETED='PHOBOS_INV_SUBMITTED_COMPLETED';
export const PHOBOS_EDIT_VERIFY_FORM_DATA_SUCCESS='PHOBOS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const PHOBOS_EDIT_VERIFY_FORM_DATA_ERROR='PHOBOS_EDIT_VERIFY_FORM_DATA_ERROR'
export const PHOBOS_UPDATE_FORM_ERROR='PHOBOS_UPDATE_FORM_ERROR'
export const REFRESH_PHOBOS_VENDORS_SUCCESS='REFRESH_PHOBOS_VENDORS_SUCCESS';
export const REFRESH_PHOBOS_VENDORS_ERROR='REFRESH_PHOBOS_VENDORS_ERROR';


// WEBPACK FOOTER //
// ./src/redux/phobos/actionTypes.js